import {gnosis,polygon,polygonAmoy,chiliz,spicy}from'viem/chains';var lpAbi = [
    { 'inputs': [], 'name': 'BetExpired', 'type': 'error',
    },
    { 'inputs': [
            { 'internalType': 'uint64', 'name': 'waitTime', 'type': 'uint64',
            },
        ], 'name': 'ClaimTimeout', 'type': 'error',
    },
    { 'inputs': [], 'name': 'CoreNotActive', 'type': 'error',
    },
    { 'inputs': [], 'name': 'DepositDoesNotExist', 'type': 'error',
    },
    { 'inputs': [], 'name': 'GameAlreadyCanceled', 'type': 'error',
    },
    { 'inputs': [], 'name': 'GameAlreadyCreated', 'type': 'error',
    },
    { 'inputs': [], 'name': 'GameCanceled_', 'type': 'error',
    },
    { 'inputs': [], 'name': 'GameNotExists', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectCoreState', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectFee', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectGameId', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectMinBet', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectMinDepo', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectPercent', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectReinforcementAbility', 'type': 'error',
    },
    { 'inputs': [], 'name': 'IncorrectTimestamp', 'type': 'error',
    },
    { 'inputs': [], 'name': 'LeafNotExist', 'type': 'error',
    },
    { 'inputs': [], 'name': 'LiquidityIsLocked', 'type': 'error',
    },
    { 'inputs': [], 'name': 'LiquidityNotOwned', 'type': 'error',
    },
    { 'inputs': [], 'name': 'NoLiquidity', 'type': 'error',
    },
    { 'inputs': [], 'name': 'NotEnoughLiquidity', 'type': 'error',
    },
    { 'inputs': [], 'name': 'OnlyFactory', 'type': 'error',
    },
    { 'inputs': [
            { 'internalType': 'enum SafeCast.Type', 'name': 'to', 'type': 'uint8',
            },
        ], 'name': 'SafeCastError', 'type': 'error',
    },
    { 'inputs': [], 'name': 'SmallBet', 'type': 'error',
    },
    { 'inputs': [], 'name': 'SmallDepo', 'type': 'error',
    },
    { 'inputs': [], 'name': 'SmallDonation', 'type': 'error',
    },
    { 'inputs': [], 'name': 'UnknownCore', 'type': 'error',
    },
    { 'inputs': [
            { 'internalType': 'uint64', 'name': 'waitTime', 'type': 'uint64',
            },
        ], 'name': 'WithdrawalTimeout', 'type': 'error',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'owner', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'address', 'name': 'approved', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'Approval', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'owner', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'address', 'name': 'operator', 'type': 'address',
            },
            { 'indexed': false, 'internalType': 'bool', 'name': 'approved', 'type': 'bool',
            },
        ], 'name': 'ApprovalForAll', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'address', 'name': 'bettor', 'type': 'address',
            },
            { 'indexed': false, 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
            { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256',
            },
        ], 'name': 'BettorWin', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'uint64', 'name': 'newClaimTimeout', 'type': 'uint64',
            },
        ], 'name': 'ClaimTimeoutChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'indexed': false, 'internalType': 'enum ILP.CoreState', 'name': 'state', 'type': 'uint8',
            },
            { 'indexed': false, 'internalType': 'uint64', 'name': 'reinforcementAbility', 'type': 'uint64',
            },
            { 'indexed': false, 'internalType': 'uint128', 'name': 'minBet', 'type': 'uint128',
            },
        ], 'name': 'CoreSettingsUpdated', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'address', 'name': 'newDataProvider', 'type': 'address',
            },
        ], 'name': 'DataProviderChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'enum ILP.FeeType', 'name': 'feeType', 'type': 'uint8',
            },
            { 'indexed': false, 'internalType': 'uint64', 'name': 'fee', 'type': 'uint64',
            },
        ], 'name': 'FeeChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
        ], 'name': 'GameCanceled', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
            { 'indexed': false, 'internalType': 'uint64', 'name': 'newStart', 'type': 'uint64',
            },
        ], 'name': 'GameShifted', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'uint8', 'name': 'version', 'type': 'uint8',
            },
        ], 'name': 'Initialized', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'account', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
            { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256',
            },
        ], 'name': 'LiquidityAdded', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'account', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
            { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256',
            },
        ], 'name': 'LiquidityDonated', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'address', 'name': 'newLiquidityManager', 'type': 'address',
            },
        ], 'name': 'LiquidityManagerChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'account', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
            { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256',
            },
        ], 'name': 'LiquidityRemoved', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'indexed': false, 'internalType': 'uint128', 'name': 'newMinBet', 'type': 'uint128',
            },
        ], 'name': 'MinBetChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'uint128', 'name': 'newMinDepo', 'type': 'uint128',
            },
        ], 'name': 'MinDepoChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
            { 'indexed': false, 'internalType': 'uint64', 'name': 'startsAt', 'type': 'uint64',
            },
            { 'indexed': false, 'internalType': 'bytes', 'name': 'data', 'type': 'bytes',
            },
        ], 'name': 'NewGame', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'previousOwner', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'address', 'name': 'newOwner', 'type': 'address',
            },
        ], 'name': 'OwnershipTransferred', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'uint128', 'name': 'newReinforcementAbility', 'type': 'uint128',
            },
        ], 'name': 'ReinforcementAbilityChanged', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': true, 'internalType': 'address', 'name': 'from', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'address', 'name': 'to', 'type': 'address',
            },
            { 'indexed': true, 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'Transfer', 'type': 'event',
    },
    { 'anonymous': false, 'inputs': [
            { 'indexed': false, 'internalType': 'uint64', 'name': 'newWithdrawTimeout', 'type': 'uint64',
            },
        ], 'name': 'WithdrawTimeoutChanged', 'type': 'event',
    },
    { 'inputs': [], 'name': 'access', 'outputs': [
            { 'internalType': 'contract IAccess', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
        ], 'name': 'addCondition', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
        ], 'name': 'addCore', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
            { 'internalType': 'bytes', 'name': 'data', 'type': 'bytes',
            },
        ], 'name': 'addLiquidity', 'outputs': [
            { 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
            { 'internalType': 'uint128', 'name': 'lockedReserve', 'type': 'uint128',
            },
            { 'internalType': 'uint128', 'name': 'finalReserve', 'type': 'uint128',
            },
            { 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
        ], 'name': 'addReserve', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'to', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'approve', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'owner', 'type': 'address',
            },
        ], 'name': 'balanceOf', 'outputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
            { 'internalType': 'uint64', 'name': 'expiresAt', 'type': 'uint64',
            },
            { 'components': [
                    { 'internalType': 'address', 'name': 'affiliate', 'type': 'address',
                    },
                    { 'internalType': 'uint64', 'name': 'minOdds', 'type': 'uint64',
                    },
                    { 'internalType': 'bytes', 'name': 'data', 'type': 'bytes',
                    },
                ], 'internalType': 'struct IBet.BetData', 'name': 'betData', 'type': 'tuple',
            },
        ], 'name': 'bet', 'outputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'bettor', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
            { 'internalType': 'uint64', 'name': 'expiresAt', 'type': 'uint64',
            },
            { 'components': [
                    { 'internalType': 'address', 'name': 'affiliate', 'type': 'address',
                    },
                    { 'internalType': 'uint64', 'name': 'minOdds', 'type': 'uint64',
                    },
                    { 'internalType': 'bytes', 'name': 'data', 'type': 'bytes',
                    },
                ], 'internalType': 'struct IBet.BetData', 'name': 'betData', 'type': 'tuple',
            },
        ], 'name': 'betFor', 'outputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
        ], 'name': 'cancelGame', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint64', 'name': 'newClaimTimeout', 'type': 'uint64',
            },
        ], 'name': 'changeClaimTimeout', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'newDataProvider', 'type': 'address',
            },
        ], 'name': 'changeDataProvider', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'enum ILP.FeeType', 'name': 'feeType', 'type': 'uint8',
            },
            { 'internalType': 'uint64', 'name': 'newFee', 'type': 'uint64',
            },
        ], 'name': 'changeFee', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'newLiquidityManager', 'type': 'address',
            },
        ], 'name': 'changeLiquidityManager', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
            { 'internalType': 'int128', 'name': 'deltaReserve', 'type': 'int128',
            },
        ], 'name': 'changeLockedLiquidity', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint128', 'name': 'newMinDepo', 'type': 'uint128',
            },
        ], 'name': 'changeMinDepo', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint64', 'name': 'newWithdrawTimeout', 'type': 'uint64',
            },
        ], 'name': 'changeWithdrawTimeout', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'account', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'target', 'type': 'address',
            },
            { 'internalType': 'bytes4', 'name': 'selector', 'type': 'bytes4',
            },
        ], 'name': 'checkAccess', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
        ], 'name': 'checkCore', 'outputs': [], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'account', 'type': 'address',
            },
        ], 'name': 'checkOwner', 'outputs': [], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'claimReward', 'outputs': [
            { 'internalType': 'uint128', 'name': 'claimedAmount', 'type': 'uint128',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [], 'name': 'claimTimeout', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'name': 'cores', 'outputs': [
            { 'internalType': 'enum ILP.CoreState', 'name': 'state', 'type': 'uint8',
            },
            { 'internalType': 'uint64', 'name': 'reinforcementAbility', 'type': 'uint64',
            },
            { 'internalType': 'uint128', 'name': 'minBet', 'type': 'uint128',
            },
            { 'internalType': 'uint128', 'name': 'lockedLiquidity', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
            { 'internalType': 'uint64', 'name': 'startsAt', 'type': 'uint64',
            },
            { 'internalType': 'bytes', 'name': 'data', 'type': 'bytes',
            },
        ], 'name': 'createGame', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [], 'name': 'dataProvider', 'outputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
            { 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
        ], 'name': 'donateLiquidity', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [], 'name': 'factory', 'outputs': [
            { 'internalType': 'contract IOwnable', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'name': 'fees', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'name': 'games', 'outputs': [
            { 'internalType': 'bytes32', 'name': 'unusedVariable', 'type': 'bytes32',
            },
            { 'internalType': 'uint128', 'name': 'lockedLiquidity', 'type': 'uint128',
            },
            { 'internalType': 'uint64', 'name': 'startsAt', 'type': 'uint64',
            },
            { 'internalType': 'bool', 'name': 'canceled', 'type': 'bool',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'getApproved', 'outputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
        ], 'name': 'getGameInfo', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
            { 'internalType': 'bool', 'name': '', 'type': 'bool',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'getLastDepositId', 'outputs': [
            { 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
        ], 'name': 'getLockedLiquidityLimit', 'outputs': [
            { 'internalType': 'uint128', 'name': '', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'getReserve', 'outputs': [
            { 'internalType': 'uint128', 'name': 'reserve', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'access_', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'dataProvider_', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'token_', 'type': 'address',
            },
            { 'internalType': 'uint128', 'name': 'minDepo_', 'type': 'uint128',
            },
            { 'internalType': 'uint64', 'name': 'daoFee', 'type': 'uint64',
            },
            { 'internalType': 'uint64', 'name': 'dataProviderFee', 'type': 'uint64',
            },
        ], 'name': 'initialize', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'owner', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'operator', 'type': 'address',
            },
        ], 'name': 'isApprovedForAll', 'outputs': [
            { 'internalType': 'bool', 'name': '', 'type': 'bool',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'depositId', 'type': 'uint256',
            },
        ], 'name': 'isDepositExists', 'outputs': [
            { 'internalType': 'bool', 'name': '', 'type': 'bool',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
        ], 'name': 'isGameCanceled', 'outputs': [
            { 'internalType': 'bool', 'name': '', 'type': 'bool',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'liquidityManager', 'outputs': [
            { 'internalType': 'contract ILiquidityManager', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'lockedLiquidity', 'outputs': [
            { 'internalType': 'uint128', 'name': '', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'minDepo', 'outputs': [
            { 'internalType': 'uint128', 'name': '', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'name', 'outputs': [
            { 'internalType': 'string', 'name': '', 'type': 'string',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'nextNode', 'outputs': [
            { 'internalType': 'uint48', 'name': '', 'type': 'uint48',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint48', 'name': 'leaf', 'type': 'uint48',
            },
        ], 'name': 'nodeWithdrawView', 'outputs': [
            { 'internalType': 'uint128', 'name': 'withdrawAmount', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'owner', 'outputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'ownerOf', 'outputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'name': 'rewards', 'outputs': [
            { 'internalType': 'int128', 'name': 'amount', 'type': 'int128',
            },
            { 'internalType': 'uint64', 'name': 'claimedAt', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'from', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'to', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'safeTransferFrom', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'from', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'to', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
            { 'internalType': 'bytes', 'name': 'data', 'type': 'bytes',
            },
        ], 'name': 'safeTransferFrom', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'operator', 'type': 'address',
            },
            { 'internalType': 'bool', 'name': 'approved', 'type': 'bool',
            },
        ], 'name': 'setApprovalForAll', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256',
            },
            { 'internalType': 'uint64', 'name': 'startsAt', 'type': 'uint64',
            },
        ], 'name': 'shiftGame', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'bytes4', 'name': 'interfaceId', 'type': 'bytes4',
            },
        ], 'name': 'supportsInterface', 'outputs': [
            { 'internalType': 'bool', 'name': '', 'type': 'bool',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'symbol', 'outputs': [
            { 'internalType': 'string', 'name': '', 'type': 'string',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'token', 'outputs': [
            { 'internalType': 'address', 'name': '', 'type': 'address',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'index', 'type': 'uint256',
            },
        ], 'name': 'tokenByIndex', 'outputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'owner', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'index', 'type': 'uint256',
            },
        ], 'name': 'tokenOfOwnerByIndex', 'outputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'tokenURI', 'outputs': [
            { 'internalType': 'string', 'name': '', 'type': 'string',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [], 'name': 'totalSupply', 'outputs': [
            { 'internalType': 'uint256', 'name': '', 'type': 'uint256',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'from', 'type': 'address',
            },
            { 'internalType': 'address', 'name': 'to', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'transferFrom', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'newOwner', 'type': 'address',
            },
        ], 'name': 'transferOwnership', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint48', 'name': '', 'type': 'uint48',
            },
        ], 'name': 'treeNode', 'outputs': [
            { 'internalType': 'uint64', 'name': 'updateId', 'type': 'uint64',
            },
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'internalType': 'enum ILP.CoreState', 'name': 'state', 'type': 'uint8',
            },
            { 'internalType': 'uint64', 'name': 'reinforcementAbility', 'type': 'uint64',
            },
            { 'internalType': 'uint128', 'name': 'minBet', 'type': 'uint128',
            },
        ], 'name': 'updateCoreSettings', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [], 'name': 'updateId', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'viewPayout', 'outputs': [
            { 'internalType': 'uint128', 'name': '', 'type': 'uint128',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint48', 'name': '', 'type': 'uint48',
            },
        ], 'name': 'withdrawAfter', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'uint48', 'name': 'depositId', 'type': 'uint48',
            },
            { 'internalType': 'uint40', 'name': 'percent', 'type': 'uint40',
            },
        ], 'name': 'withdrawLiquidity', 'outputs': [
            { 'internalType': 'uint128', 'name': 'withdrawnAmount', 'type': 'uint128',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'withdrawPayout', 'outputs': [
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
    { 'inputs': [], 'name': 'withdrawTimeout', 'outputs': [
            { 'internalType': 'uint64', 'name': '', 'type': 'uint64',
            },
        ], 'stateMutability': 'view', 'type': 'function',
    },
    { 'stateMutability': 'payable', 'type': 'receive',
    },
];var liveCoreAbi = [
    {
        'inputs': [],
        'stateMutability': 'nonpayable',
        'type': 'constructor',
    },
    {
        'inputs': [],
        'name': 'AlreadyPaid',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetNotExists',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionAlreadyResolved',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotFinished',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotRunning',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'DuplicateOutcomes',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectAffiliate',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectAmount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectConditionIds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectCore',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectSettleDate',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectWinningOutcomesCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidBettorSignature',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidChainId',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidNonce',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidOracleSignature',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyLp',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'name': 'OnlyOracle',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'PayoutLimit',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'enum SafeCast.Type',
                'name': 'to',
                'type': 'uint8',
            },
        ],
        'name': 'SafeCastError',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SignatureExpired',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SmallOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'WrongOutcome',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'gameId',
                'type': 'uint256',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint64[]',
                'name': 'outcomes',
                'type': 'uint64[]',
            },
            {
                'indexed': false,
                'internalType': 'uint256[]',
                'name': 'odds',
                'type': 'uint256[]',
            },
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'winningOutcomesCount',
                'type': 'uint8',
            },
        ],
        'name': 'ConditionCreated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'indexed': false,
                'internalType': 'uint64[]',
                'name': 'winningOutcomes',
                'type': 'uint64[]',
            },
            {
                'indexed': false,
                'internalType': 'int128',
                'name': 'lpProfit',
                'type': 'int128',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'settledAt',
                'type': 'uint64',
            },
        ],
        'name': 'ConditionResolved',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'version',
                'type': 'uint8',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'affiliate',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'outcomeId',
                'type': 'uint64',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'nonce',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'odds',
                'type': 'uint64',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'payoutLimit',
                'type': 'uint128',
            },
        ],
        'name': 'NewLiveBet',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'inputs': [],
        'name': 'MAX_OUTCOMES_COUNT',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'azuroBet',
        'outputs': [
            {
                'internalType': 'contract IAzuroBet',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'bets',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'payout',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
            {
                'internalType': 'uint64',
                'name': 'timestamp',
                'type': 'uint64',
            },
            {
                'internalType': 'bool',
                'name': 'isPaid',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256[]',
                'name': 'conditionIds',
                'type': 'uint256[]',
            },
        ],
        'name': 'cancelConditions',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'checkOwner',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'conditions',
        'outputs': [
            {
                'internalType': 'int128',
                'name': 'maxReserved',
                'type': 'int128',
            },
            {
                'internalType': 'uint128',
                'name': 'totalNetBets',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'settledAt',
                'type': 'uint64',
            },
            {
                'internalType': 'uint48',
                'name': 'lastDepositId',
                'type': 'uint48',
            },
            {
                'internalType': 'uint8',
                'name': 'winningOutcomesCount',
                'type': 'uint8',
            },
            {
                'internalType': 'enum IConditionState.ConditionState',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'internalType': 'address',
                'name': 'oracle',
                'type': 'address',
            },
            {
                'internalType': 'bool',
                'name': 'isExpressForbidden',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'getCondition',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'int128',
                        'name': 'maxReserved',
                        'type': 'int128',
                    },
                    {
                        'internalType': 'uint128[]',
                        'name': 'payouts',
                        'type': 'uint128[]',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'totalNetBets',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'settledAt',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'lastDepositId',
                        'type': 'uint48',
                    },
                    {
                        'internalType': 'uint8',
                        'name': 'winningOutcomesCount',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'enum IConditionState.ConditionState',
                        'name': 'state',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isExpressForbidden',
                        'type': 'bool',
                    },
                ],
                'internalType': 'struct IClientCondition.Condition',
                'name': '',
                'type': 'tuple',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'getOutcomeIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'azuroBet_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'lp_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'isConditionCanceled',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'isOutcomeWinning',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lp',
        'outputs': [
            {
                'internalType': 'contract ILP',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'nonces',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'outcomeNumbers',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'affiliate',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'minOdds',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'data',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IBet.BetData',
                'name': 'betData',
                'type': 'tuple',
            },
        ],
        'name': 'putBet',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'conditionId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint64[]',
                        'name': 'winningOutcomes',
                        'type': 'uint64[]',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'settledAt',
                        'type': 'uint64',
                    },
                ],
                'internalType': 'struct IClientCoreBase.ResolveData[]',
                'name': 'data',
                'type': 'tuple[]',
            },
        ],
        'name': 'resolveConditions',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'resolvePayout',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'snapshotTimes',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'snapshots',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'totalNetBets',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'viewPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'winningOutcomes',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
];var prematchComboCoreAbi = [
    {
        'inputs': [],
        'name': 'AlreadyPaid',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetNotExists',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'ConditionNotFinished',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'ConditionNotRunning',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectMaxOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LargeOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyLp',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'enum SafeCast.Type',
                'name': 'to',
                'type': 'uint8',
            },
        ],
        'name': 'SafeCastError',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SameGameIdsNotAllowed',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SmallOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'TooFewSubbets',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'TooLargeReinforcement',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'WrongToken',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'approved',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'Approval',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'approved',
                'type': 'bool',
            },
        ],
        'name': 'ApprovalForAll',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'version',
                'type': 'uint8',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'newMaxOdds',
                'type': 'uint256',
            },
        ],
        'name': 'MaxOddsChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'affiliate',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'betId',
                'type': 'uint256',
            },
            {
                'components': [
                    {
                        'internalType': 'uint64',
                        'name': 'odds',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'amount',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'lastDepositId',
                        'type': 'uint48',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isClaimed',
                        'type': 'bool',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint64',
                                'name': 'outcomeId',
                                'type': 'uint64',
                            },
                        ],
                        'internalType': 'struct ICoreBase.CoreBetData[]',
                        'name': 'subBets',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'uint64[]',
                        'name': 'conditionOdds',
                        'type': 'uint64[]',
                    },
                ],
                'indexed': false,
                'internalType': 'struct IBetExpress.Bet',
                'name': 'bet',
                'type': 'tuple',
            },
        ],
        'name': 'NewBet',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'newReinforcement',
                'type': 'uint128',
            },
        ],
        'name': 'ReinforcementChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'Transfer',
        'type': 'event',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'approve',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'balanceOf',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'baseURI',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'conditionId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'outcomeId',
                        'type': 'uint64',
                    },
                ],
                'internalType': 'struct ICoreBase.CoreBetData[]',
                'name': 'subBets',
                'type': 'tuple[]',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'calcOdds',
        'outputs': [
            {
                'internalType': 'uint64[]',
                'name': 'conditionOdds',
                'type': 'uint64[]',
            },
            {
                'internalType': 'uint256',
                'name': 'expressOdds',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'calcPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'newMaxOdds',
                'type': 'uint256',
            },
        ],
        'name': 'changeMaxOdds',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'newReinforcement',
                'type': 'uint128',
            },
        ],
        'name': 'changeReinforcement',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'checkOwner',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'core',
        'outputs': [
            {
                'internalType': 'contract ICoreBase',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'getApproved',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'betId',
                'type': 'uint256',
            },
        ],
        'name': 'getBet',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint64',
                        'name': 'odds',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'amount',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'lastDepositId',
                        'type': 'uint48',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isClaimed',
                        'type': 'bool',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint64',
                                'name': 'outcomeId',
                                'type': 'uint64',
                            },
                        ],
                        'internalType': 'struct ICoreBase.CoreBetData[]',
                        'name': 'subBets',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'uint64[]',
                        'name': 'conditionOdds',
                        'type': 'uint64[]',
                    },
                ],
                'internalType': 'struct IBetExpress.Bet',
                'name': 'betInfo',
                'type': 'tuple',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'lp_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'core_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
        ],
        'name': 'isApprovedForAll',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lastBetId',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'lockedReserves',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lp',
        'outputs': [
            {
                'internalType': 'contract ILP',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'maxOdds',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'name',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ownerOf',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'affiliate',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'minOdds',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'data',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IBet.BetData',
                'name': 'betData',
                'type': 'tuple',
            },
        ],
        'name': 'putBet',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'betId',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'reinforcement',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'resolvePayout',
        'outputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'payout',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'safeTransferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'internalType': 'bytes',
                'name': 'data',
                'type': 'bytes',
            },
        ],
        'name': 'safeTransferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'internalType': 'bool',
                'name': 'approved',
                'type': 'bool',
            },
        ],
        'name': 'setApprovalForAll',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'string',
                'name': 'uri',
                'type': 'string',
            },
        ],
        'name': 'setBaseURI',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'bytes4',
                'name': 'interfaceId',
                'type': 'bytes4',
            },
        ],
        'name': 'supportsInterface',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'symbol',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'tokenURI',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'transferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'viewPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
];var prematchCoreAbi = [
    {
        'inputs': [],
        'name': 'AlreadyPaid',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetNotExists',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'CantChangeFlag',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionAlreadyCreated',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionAlreadyResolved',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotExists',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotFinished',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotRunning',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'DuplicateOutcomes',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'GameAlreadyStarted',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectConditionId',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectMargin',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectOutcomesCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectReinforcement',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectTimestamp',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectWinningOutcomesCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InsufficientFund',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NoPendingReward',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NothingChanged',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyLp',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'name': 'OnlyOracle',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OutcomesAndOddsCountDiffer',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'waitTime',
                'type': 'uint64',
            },
        ],
        'name': 'ResolveTooEarly',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'enum SafeCast.Type',
                'name': 'to',
                'type': 'uint8',
            },
        ],
        'name': 'SafeCastError',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SmallOdds',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'pendingRewardsCount',
                'type': 'uint256',
            },
        ],
        'name': 'StartOutOfRange',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'WrongOutcome',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ZeroOdds',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'gameId',
                'type': 'uint256',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint64[]',
                'name': 'outcomes',
                'type': 'uint64[]',
            },
        ],
        'name': 'ConditionCreated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'indexed': false,
                'internalType': 'uint64[]',
                'name': 'winningOutcomes',
                'type': 'uint64[]',
            },
            {
                'indexed': false,
                'internalType': 'int128',
                'name': 'lpProfit',
                'type': 'int128',
            },
        ],
        'name': 'ConditionResolved',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'flag',
                'type': 'bool',
            },
        ],
        'name': 'ConditionStopped',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'version',
                'type': 'uint8',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'newMargin',
                'type': 'uint64',
            },
        ],
        'name': 'MarginChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'affiliate',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'outcomeId',
                'type': 'uint64',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'odds',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint128[]',
                'name': 'funds',
                'type': 'uint128[]',
            },
        ],
        'name': 'NewBet',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint256[]',
                'name': 'newOdds',
                'type': 'uint256[]',
            },
        ],
        'name': 'OddsChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'newReinforcement',
                'type': 'uint128',
            },
        ],
        'name': 'ReinforcementChanged',
        'type': 'event',
    },
    {
        'inputs': [],
        'name': 'MAX_OUTCOMES_COUNT',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'azuroBet',
        'outputs': [
            {
                'internalType': 'contract IAzuroBet',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'bets',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'payout',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
            {
                'internalType': 'bool',
                'name': 'isPaid',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'calcOdds',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': 'odds',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'cancelCondition',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint64',
                'name': 'newMargin',
                'type': 'uint64',
            },
        ],
        'name': 'changeMargin',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256[]',
                'name': 'newOdds',
                'type': 'uint256[]',
            },
        ],
        'name': 'changeOdds',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'newReinforcement',
                'type': 'uint128',
            },
        ],
        'name': 'changeReinforcement',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'checkOwner',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'conditions',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'gameId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'totalNetBets',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'reinforcement',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'fund',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'margin',
                'type': 'uint64',
            },
            {
                'internalType': 'uint64',
                'name': 'endsAt',
                'type': 'uint64',
            },
            {
                'internalType': 'uint48',
                'name': 'lastDepositId',
                'type': 'uint48',
            },
            {
                'internalType': 'uint8',
                'name': 'winningOutcomesCount',
                'type': 'uint8',
            },
            {
                'internalType': 'enum ICondition.ConditionState',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'internalType': 'address',
                'name': 'oracle',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'gameId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256[]',
                'name': 'odds',
                'type': 'uint256[]',
            },
            {
                'internalType': 'uint64[]',
                'name': 'outcomes',
                'type': 'uint64[]',
            },
            {
                'internalType': 'uint128',
                'name': 'reinforcement',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'margin',
                'type': 'uint64',
            },
            {
                'internalType': 'uint8',
                'name': 'winningOutcomesCount',
                'type': 'uint8',
            },
        ],
        'name': 'createCondition',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'getCondition',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'gameId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint128[]',
                        'name': 'payouts',
                        'type': 'uint128[]',
                    },
                    {
                        'internalType': 'uint128[]',
                        'name': 'virtualFunds',
                        'type': 'uint128[]',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'totalNetBets',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'reinforcement',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'fund',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'margin',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'endsAt',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'lastDepositId',
                        'type': 'uint48',
                    },
                    {
                        'internalType': 'uint8',
                        'name': 'winningOutcomesCount',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'enum ICondition.ConditionState',
                        'name': 'state',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                ],
                'internalType': 'struct ICondition.Condition',
                'name': '',
                'type': 'tuple',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'getOutcomeIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'azuroBet_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'lp_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'isConditionCanceled',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint64',
                'name': 'outcome',
                'type': 'uint64',
            },
        ],
        'name': 'isOutcomeWinning',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lp',
        'outputs': [
            {
                'internalType': 'contract ILP',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'outcomeNumbers',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'affiliate',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'minOdds',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'data',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IBet.BetData',
                'name': 'betData',
                'type': 'tuple',
            },
        ],
        'name': 'putBet',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint64[]',
                'name': 'winningOutcomes_',
                'type': 'uint64[]',
            },
        ],
        'name': 'resolveCondition',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'resolvePayout',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'bool',
                'name': 'flag',
                'type': 'bool',
            },
        ],
        'name': 'stopCondition',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'viewPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'winningOutcomes',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
];var proxyFrontAbi = [
    {
        'inputs': [],
        'stateMutability': 'nonpayable',
        'type': 'constructor',
    },
    {
        'inputs': [],
        'name': 'IncorrectValue',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'version',
                'type': 'uint8',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'lp',
                'type': 'address',
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'core',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'amount',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'expiresAt',
                        'type': 'uint64',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'address',
                                'name': 'affiliate',
                                'type': 'address',
                            },
                            {
                                'internalType': 'uint64',
                                'name': 'minOdds',
                                'type': 'uint64',
                            },
                            {
                                'internalType': 'bytes',
                                'name': 'data',
                                'type': 'bytes',
                            },
                        ],
                        'internalType': 'struct IBet.BetData',
                        'name': 'extraData',
                        'type': 'tuple',
                    },
                ],
                'internalType': 'struct IProxyFront.BetData[]',
                'name': 'data',
                'type': 'tuple[]',
            },
        ],
        'name': 'bet',
        'outputs': [],
        'stateMutability': 'payable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'checkOwner',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'core',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'tokenId',
                        'type': 'uint256',
                    },
                ],
                'internalType': 'struct IProxyFront.WithdrawPayoutData[]',
                'name': 'data',
                'type': 'tuple[]',
            },
        ],
        'name': 'withdrawPayouts',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'stateMutability': 'payable',
        'type': 'receive',
    },
];const DEFAULT_CACHE_TIME = 3 * 60;
const DEFAULT_DEADLINE = 300; // 5 min
const ODDS_DECIMALS = 12;
const configRef = {
    gamesCacheTime: DEFAULT_CACHE_TIME,
};
const getGraphqlPrematchEndpoint = (network) => `https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-${network}-v3`;
const getGraphqlLiveEndpoint = (chainId) => {
    if (chainId === polygonAmoy.id) {
        return 'https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-live-data-feed-preprod';
    }
    if (chainId === spicy.id) {
        return 'https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-live-data-feed-dev';
    }
    return 'https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-live-data-feed';
};
const getSocketEndpoint = (chainId) => {
    if (chainId === polygonAmoy.id) {
        return 'wss://preprod-streams.azuro.org/v1/streams/conditions';
    }
    if (chainId === spicy.id) {
        return 'wss://dev-streams.azuro.org/v1/streams/conditions';
    }
    return 'wss://streams.azuro.org/v1/streams/conditions';
};
const getApiUrl = (chainId) => {
    if (chainId === polygonAmoy.id) {
        return 'https://preprod-api.azuro.org/api/v1/public';
    }
    if (chainId === spicy.id) {
        return 'https://dev-api.azuro.org/api/v1/public';
    }
    return 'https://api.azuro.org/api/v1/public';
};
const deBridgeUrl = 'https://api.dln.trade/v1.0';
const deBridgeTxUrl = 'https://stats-api.dln.trade/api';
const setupContracts = ({ lp, prematchCore, prematchComboCore, proxyFront, liveRelayer, liveCore }) => {
    const contracts = {
        lp: {
            address: lp,
            abi: lpAbi,
        },
        prematchCore: {
            address: prematchCore,
            abi: prematchCoreAbi,
        },
        prematchComboCore: {
            address: prematchComboCore,
            abi: prematchComboCoreAbi,
        },
        proxyFront: {
            address: proxyFront,
            abi: proxyFrontAbi,
        },
    };
    if (liveRelayer) {
        contracts.liveRelayer = {
            address: liveRelayer,
        };
    }
    if (liveCore) {
        contracts.liveCore = {
            address: liveCore,
            abi: liveCoreAbi,
        };
    }
    return contracts;
};
var Environment;
(function (Environment) {
    Environment["GnosisXDAI"] = "GnosisXDAI";
    Environment["PolygonUSDT"] = "PolygonUSDT";
    Environment["PolygonAmoyAZUSD"] = "PolygonAmoyAZUSD";
    Environment["ChilizWCHZ"] = "ChilizWCHZ";
    Environment["ChilizSpicyWCHZ"] = "ChilizSpicyWCHZ";
})(Environment || (Environment = {}));
const environments = {
    [gnosis.id]: Environment.GnosisXDAI,
    [polygon.id]: Environment.PolygonUSDT,
    [polygonAmoy.id]: Environment.PolygonAmoyAZUSD,
    [chiliz.id]: Environment.ChilizWCHZ,
    [spicy.id]: Environment.ChilizSpicyWCHZ,
};
const gnosisData = {
    chain: gnosis,
    graphql: {
        prematch: getGraphqlPrematchEndpoint('gnosis'),
        live: getGraphqlLiveEndpoint(gnosis.id),
    },
    socket: getSocketEndpoint(gnosis.id),
    api: getApiUrl(gnosis.id),
    environment: environments[gnosis.id],
    contracts: setupContracts({
        lp: '0x204e7371Ade792c5C006fb52711c50a7efC843ed',
        prematchCore: '0x7f3F3f19c4e4015fd9Db2f22e653c766154091EF',
        prematchComboCore: '0xDbC3BE2DDB53e1a288F7b7a4d020F8056D3b0F7C',
        proxyFront: '0x3A1c6640daeAc3513726F06A9f03911CC1080251',
        liveRelayer: '0x936c02503A32aA23BCF7CFaF5c29100b0F93FCfe',
        liveCore: '0x0223ff7efca5aec919c471fa2eb44cda466f1500',
    }),
    betToken: {
        address: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
        symbol: 'WXDAI',
        decimals: 18,
    },
};
const polygonData = {
    chain: polygon,
    graphql: {
        prematch: getGraphqlPrematchEndpoint('polygon'),
        live: getGraphqlLiveEndpoint(polygon.id),
    },
    socket: getSocketEndpoint(polygon.id),
    api: getApiUrl(polygon.id),
    environment: environments[polygon.id],
    contracts: setupContracts({
        lp: '0x7043E4e1c4045424858ECBCED80989FeAfC11B36',
        prematchCore: '0xA40F8D69D412b79b49EAbdD5cf1b5706395bfCf7',
        prematchComboCore: '0x92a4e8Bc6B92a2e1ced411f41013B5FE6BE07613',
        proxyFront: '0x0DEE52b98ba8326DaD4C346a4F806Fd871360a00',
        liveRelayer: '0xC6BB817a7f02874F360d135D880200A2E440207D',
        liveCore: '0xc389558Faca41bC747F763cf8616704187CDcD04',
    }),
    betToken: {
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        symbol: 'USDT',
        decimals: 6,
    },
};
const polygonAmoyData = {
    chain: polygonAmoy,
    graphql: {
        prematch: getGraphqlPrematchEndpoint('polygon-amoy-preprod'),
        live: getGraphqlLiveEndpoint(polygonAmoy.id),
    },
    socket: getSocketEndpoint(polygonAmoy.id),
    api: getApiUrl(polygonAmoy.id),
    environment: environments[polygonAmoy.id],
    contracts: setupContracts({
        lp: '0x3528186476FD0eA0AdC9fCcc41de4CD138f99653',
        prematchCore: '0x2477B960080B3439b4684df3D9CE53B2ACe64315',
        prematchComboCore: '0xdF71998f7931caD24439A12A2F56D7326C3D0295',
        proxyFront: '0x7003CaA0847CA296EBF51C43D9021656a663304f',
        liveRelayer: '0x355B8493380fA5D57E4d3aFBF7C5f38b64AD5eA9',
        liveCore: '0x51eD5C2596d9AE32cE53ac1915Cb9333AFeF3156',
    }),
    betToken: {
        address: '0xf028b2dd00e20a8d9db3964a5feb0633d2ee46cd',
        symbol: 'AZUSD',
        decimals: 6,
    },
};
const chilizData = {
    chain: chiliz,
    graphql: {
        prematch: getGraphqlPrematchEndpoint('chiliz'),
        live: getGraphqlLiveEndpoint(chiliz.id),
    },
    socket: getSocketEndpoint(chiliz.id),
    api: getApiUrl(chiliz.id),
    environment: environments[chiliz.id],
    contracts: setupContracts({
        lp: '0x6909eAD2a1DA7b632D5993d329DEf4d2dbBc8261',
        prematchCore: '0x1a21C681Cc83889f4b213485aB6cF4971C43114B',
        prematchComboCore: '0x724fa8931428D5B636F7191d3e848f28Ab23C425',
        proxyFront: '0x45779134E5091756601Cb5bA389f9C76b914E520',
    }),
    betToken: {
        address: '0x677F7e16C7Dd57be1D4C8aD1244883214953DC47',
        symbol: 'WCHZ',
        decimals: 18,
    },
};
const spicyData = {
    chain: spicy,
    graphql: {
        prematch: getGraphqlPrematchEndpoint('chiliz-spicy-dev'),
        live: getGraphqlLiveEndpoint(spicy.id),
    },
    socket: getSocketEndpoint(spicy.id),
    api: getApiUrl(spicy.id),
    environment: environments[spicy.id],
    contracts: setupContracts({
        lp: '0x82f25d2670994b218b8a4C1e5Acc120D6c27d786',
        prematchCore: '0x035AB843C9F6dCB9D9bDeAC18c191dEc6c975fB7',
        prematchComboCore: '0xF94a49F0D78eAfeda81c785131eb6419EB18b33A',
        proxyFront: '0x67f3228fD58f5A26D93a5dd0c6989b69c95618eB',
    }),
    betToken: {
        address: '0x721ef6871f1c4efe730dce047d40d1743b886946',
        symbol: 'WCHZ',
        decimals: 18,
    },
};
const chainsData = {
    [gnosis.id]: gnosisData,
    [polygon.id]: polygonData,
    [polygonAmoy.id]: polygonAmoyData,
    [chiliz.id]: chilizData,
    [spicy.id]: spicyData,
};
const liveHostAddress = '0x67Fca88E2f5F2C33b86bFa4EccfCb8dCD6a56D17';
const liveSupportedChains = [polygon.id, gnosis.id, polygonAmoy.id];
const minLiveBetAmount = 1;
const cookieKeys = {
    appChainId: 'appChainId',
    live: 'live',
};
const localStorageKeys = {
    betslipItems: 'betslipItems',
};export{DEFAULT_DEADLINE as D,ODDS_DECIMALS as O,cookieKeys as a,configRef as b,chainsData as c,prematchComboCoreAbi as d,localStorageKeys as e,liveSupportedChains as f,getApiUrl as g,environments as h,liveCoreAbi as i,deBridgeUrl as j,deBridgeTxUrl as k,liveHostAddress as l,minLiveBetAmount as m,prematchCoreAbi as p};